<template>
  <b-modal
    id="import-modal"
    v-model="isShowModal"
    title="Chuyển TB tới MC nguồn CTV"
    size="lg"
    @hide="handleClose"
  >
    <div class="modal-body">
      <div class="d-flex justify-content-between">
        <div style="width: 550px">
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Tên kho</label>
            <div class="col-sm-7">
              <Select2
                v-model="payload.inventoryIds"
                :options="dataType"
                @change="changeLoadData"
                placeholder="Chọn loại kho để hiển thị danh sách"
              />
            </div>
          </div>
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Mã vận đơn </label>
            <div class="col-sm-7">
              <input
                class="w-100"
                placeholder="Nhập ghi chú"
                v-model="payload.trackingCode"
                required
              />
            </div>
          </div>
          <div class="form-group row">
            <label for class="col-sm-3 col-form-label">Ghi chú </label>
            <div class="col-sm-7">
              <textarea
                class="w-100"
                placeholder="Nhập ghi chú"
                v-model="payload.notes"
                :row="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div>
          <div
            v-show="selectedDevices?.length"
            class="text-nowrap ml-auto text-primary cursor-pointer clean-select mt-3"
            style="font-size: 16px"
          >
            Đã chọn:
            <strong class="text-danger">{{
              selectedDevices.length.toLocaleString('vi-VN')
            }}</strong>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="mb-3">
        <div class="d-flex flex-row">
          <div
            class="w-100"
            style="display: flex; align-items: center; justify-content: space-between"
          >
            <div>
              <h6 class="mb-1">Danh sách TB cần chuyển kho MC tự kích hoạt</h6>
              <div class="box-search" style="padding: 0">
                <div class="form-group">
                  <SearchStaffAutocomplete
                    :maxShow="20"
                    v-model="search.categoryId"
                    :list="optionType"
                    placeholder="Chọn/Tìm kiếm thiết bị"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    v-model.trim="search.serial"
                    class="form-control f12 hc-37 text-search"
                    placeholder="Mã serial"
                  />
                </div>
                <div class="form-group form-group-action">
                  <button
                    @click="submitForm"
                    class="pt-2 mr-2 btn btn-primary hc-37"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Lọc"
                  >
                    <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
                  </button>
                  <button
                    @click="removeForm"
                    type="button"
                    class="pt-2 mr-2 btn btn-outline-light hc-37"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Bỏ lọc"
                  >
                    <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-table
          :items="dataTable"
          :fields="fields"
          striped
          hover
          sticky-header
          responsive
          :fixed="true"
          :bordered="true"
          :busy.sync="isLoading"
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle" />
            </div>
          </template>
          <template #empty>
            <div class="text-center text-info my-2">Không có dữ liệu</div>
          </template>
          <template #emptyfiltered="{ emptyFilteredText }">
            <h4>{{ emptyFilteredText }}</h4>
          </template>

          <template #head(checkbox)>
            <b-form-checkbox
              v-model="selectAll"
              @change="toggleSelectAll"
              :disabled="isLoading || loadingComfirm"
            />
          </template>
          <template #cell(checkbox)="{ item }">
            <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
          </template>
        </b-table>
        <div class="d-flex justify-content-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="totalCount"
            :per-page="pagination.limit"
            @change="onChangePage"
          />
        </div>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="light" @click="handleClose"> Hủy </b-button>
      <b-button
        :disabled="loadingComfirm || selectedDevices?.length <= 0"
        variant="primary"
        @click="handleConfirm"
      >
        {{ loadingComfirm ? 'Đang lưu...' : 'Xác nhận' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { showMess } from '@/config/utils'
  import { DeviceService } from '@/services/device.service'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'

  export default {
    name: 'PopupList',
    props: ['onLoad', 'request'],
    components: {
      SearchStaffAutocomplete,
    },
    data() {
      return {
        isShowModal: false,
        loadingComfirm: false,
        isLoading: false,
        selectAll: false,
        dataTable: [],
        dataPayload: {},
        payload: {
          inventoryIds: null,
          note: '',
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataType: [],
        selectedDevices: [], // Thay đổi từ idsSelected thành selectedDevices để lưu thông tin đầy đủ
        maxtSelect: 0,
        totalCount: 0,
        pagination: {
          page: 1,
          total: 0,
          limit: 15,
        },
        optionType: [],
        search: {
          serial: '',
          categoryId: '',
        },
        fields: [
          {
            key: 'checkbox',
            label: 'Chọn',
            tdClass: 'text-center',
            thClass: 'text-center',
            thStyle: { width: '40px' },
          },
          {
            key: 'serial',
            label: 'Serial',
          },
          {
            key: 'categoryName',
            label: 'Tên TB',
            thStyle: { 'min-width': '200px', width: '200px' },
          },
          {
            key: 'note',
            label: 'Ghi chú',
          },
        ],
      }
    },

    created() {
      this.getDataType()
      this.typeDeviceConfig()
    },

    methods: {
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          serial: '',
          categoryId: '',
        }
        this.pagination = {
          page: 1,
          total: 0,
          limit: 15,
        }
        await this.fetchData()
      },
      // show modal
      show(myNpmerchantId) {
        this.payload.myNpmerchantId = myNpmerchantId
        this.isShowModal = true
        this.fetchData()
      },
      changeLoadData(item) {
        this.payload.inventoryIds = item
        this.onClearSelect()
        this.fetchData()
      },

      toggleSelectAll() {
        const value = this.selectAll
        for (const item of this.dataTable) {
          item.checked = value
          const existingIndex = this.selectedDevices.findIndex(device => device.id === item.id)

          if (value) {
            // Nếu chọn tất cả và thiết bị chưa có trong danh sách đã chọn
            if (existingIndex === -1) {
              this.selectedDevices.push({
                id: item.id,
                serial: item.serial,
                categoryName: item.categoryName,
                abbreviation: item.abbreviation,
              })
            }
          } else {
            // Nếu bỏ chọn tất cả và thiết bị có trong danh sách đã chọn
            if (existingIndex >= 0) {
              this.selectedDevices.splice(existingIndex, 1)
            }
          }
        }
        this.cleanSelectIfOver()
      },

      toggleSelectOne(item) {
        const existingIndex = this.selectedDevices.findIndex(device => device.id === item.id)

        if (item.checked) {
          // Nếu chọn thiết bị và chưa có trong danh sách
          if (existingIndex === -1) {
            this.selectedDevices.push({
              id: item.id,
              serial: item.serial,
              categoryName: item.categoryName,
              abbreviation: item.abbreviation,
            })
          }
        } else {
          // Nếu bỏ chọn thiết bị và có trong danh sách
          if (existingIndex >= 0) {
            this.selectedDevices.splice(existingIndex, 1)
          }
        }

        this.selectAll = this.dataTable.every(item => item.checked)
        this.cleanSelectIfOver()
      },

      onClearSelect() {
        this.selectedDevices = []
        this.selectAll && (this.selectAll = false)
        this.dataTable.forEach(item => {
          item.checked && (item.checked = false)
        })
      },

      cleanSelectIfOver() {
        this.selectedDevices.length > this.maxtSelect &&
          (() => {
            this.selectedDevices = this.selectedDevices.slice(-this.maxtSelect)
          })()
      },

      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getDataType() {
        try {
          const res = await DeviceService.getListWarehouseUserActive()
          if (res.code === 1000) {
            this.dataType = res.data?.map(i => ({
              id: i.id,
              text: i.name,
            }))
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi không tìm thấy dữ liệu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Lỗi không tìm thấy dữ liệu',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      async onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        await this.fetchData()
      },

      // đóng modal
      handleClose() {
        this.isShowModal = false
        this.dataTable = []
        this.selectedDevices = []
      },

      async fetchData() {
        try {
          this.isLoading = true
          if (this.search.categoryId === '0') delete this.search.categoryId

          const params = {
            ...(this.payload?.inventoryIds && {
              inventoryIds: [this.payload.inventoryIds],
            }),
            status: ['AVAILABILITY', 'USED'],
            limit: this.pagination.limit,
            page: this.pagination.page,
            ...this.search,
          }
          const res = await DeviceService.listDevice(params)
          if (res.code === 1000) {
            // Lấy danh sách mới
            const newDevices = res.data?.devices || []

            this.dataTable = newDevices.map(item => {
              const selectedItem = this.selectedDevices.find(
                selectedDevice => selectedDevice.id === item.id
              )
              if (selectedItem) {
                return {
                  ...item,
                  checked: true,
                }
              }
              return {
                ...item,
                checked: false,
              }
            })

            this.pagination.total = res.data?.count || 0
            this.totalCount = res.data?.count || 0
            this.maxtSelect = res.data.count || 0

            if (this.dataTable.length > 0) {
              this.selectAll = this.dataTable.every(item => item.checked)
            } else {
              this.selectAll = false
            }
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi không tìm thấy dữ liệu',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.message || 'Lỗi không tìm thấy dữ liệu',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      // xac nhận
      async handleConfirm() {
        this.loadingComfirm = true
        try {
          const devices = this.selectedDevices.map(device => ({
            deviceCode: device.abbreviation,
            serial: device.serial,
            deviceName: device.categoryName,
          }))

          const res = await DeviceService.leadAddDeviceSerial({
            devices: devices,
            note: this.payload.note || '',
            myNpmerchantId: this.payload.myNpmerchantId,
            userId: this.dataUser.userId,
            userName: this.dataUser.username,
            trackingCode: this.payload.trackingCode,
          })

          if (res.code === 1000) {
            showMess(
              this,
              'Success',
              res.message || 'Xác nhận thành công',
              'success',
              'b-toaster-top-right',
              5 * 60 * 60
            )
            this.$emit('onLoad')
            this.isShowModal = false
            this.onClearSelect()
          } else {
            showMess(
              this,
              'Error',
              res.message || 'Lỗi xác nhận',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (error) {
          showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.loadingComfirm = false
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .modal-body {
    padding-top: 0;
    max-height: 70vh;
    height: 70vh;
    overflow-y: auto;

    .radio-group {
      display: flex;
      justify-items: center;
    }
  }

  :deep(.modal-xl) {
    max-width: 1200px;
  }

  :deep(.form-control-sm) {
    height: 37px !important;
    padding: 0.375rem 0.75rem;
  }
</style>
